export default __webpack_public_path__ + "static/media/person_1@3x.0622e6b9.png";